<template>
  <div id="app">
    <MyFirstSurvey />
  </div>
</template>

<script>
import MyFirstSurvey from "./components/MyFirstSurvey.vue";

export default {
  name: 'App',
  components: {
    MyFirstSurvey
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
